import { useQuery } from "@tanstack/react-query";
import { GraduationCapIcon, SpinnerGapIcon } from "@phosphor-icons/react";
import { fetchGraduates } from "../lib/api";
import { useChain } from "../context/ChainContext";
import { CoinTable } from "./CoinTable";
import { filterByAge, ageLabel } from "./AgeFilter";
import { useGlobalAge } from "../context/AgeFilterContext";

export const FreshGraduates = () => {
  const { chain } = useChain();
  const { age } = useGlobalAge();
  const { data, isLoading } = useQuery({
    queryKey: ["graduates"],
    queryFn: fetchGraduates,
    refetchInterval: 30000,
    placeholderData: (p) => p,
    enabled: chain === "solana",
  });
  if (chain !== "solana") return null;
  const allCoins = data?.coins || [];
  const coins = filterByAge(allCoins, age);

  return (
    <div className="space-y-3 border-t border-white/10 pt-8" data-testid="fresh-graduates">
      <div className="flex items-center gap-2.5">
        <GraduationCapIcon size={24} weight="fill" style={{ color: "#22D3EE" }} />
        <h2 className="font-heading font-black text-2xl sm:text-3xl tracking-tighter leading-none">
          FRESH <span style={{ color: "#22D3EE" }}>GRADUATES</span>
        </h2>
      </div>
      <p className="text-sm text-muted-foreground max-w-2xl">
        Pump.fun tokens that just <span style={{ color: "#22D3EE" }} className="font-semibold">graduated the bonding curve</span> and are
        already ripping — accelerating volume + buy pressure while still cheap, before they hit the mainstream Radar.
        Tap any token for its full Degen Score, chart &amp; rug forensics. <span className="text-warn font-semibold">High risk — DYOR.</span>
      </p>
      {isLoading ? (
        <div className="flex justify-center py-14"><SpinnerGapIcon size={28} className="animate-spin" style={{ color: "#22D3EE" }} /></div>
      ) : allCoins.length === 0 ? (
        <div className="border border-white/10 bg-card py-14 text-center text-muted-foreground font-mono text-sm" data-testid="fresh-graduates-empty">
          No fresh graduates ripping right now — the moment one graduates &amp; accelerates, it lands here live. 🎓
        </div>
      ) : coins.length === 0 ? (
        <div className="border border-white/10 bg-card py-14 text-center text-muted-foreground font-mono text-sm">
          No graduates under {ageLabel(age)} old right now — widen the age filter at the top.
        </div>
      ) : (
        <>
          <div className="text-xs font-mono text-muted-foreground">{coins.length} fresh graduate{coins.length === 1 ? "" : "s"} 🎓</div>
          <CoinTable coins={coins} sort="score" order="desc" onSort={() => {}} />
        </>
      )}
    </div>
  );
};
